import React from "react";
import PropTypes from "prop-types";
import InfiniteScroll from "react-infinite-scroller";
// import { Grid } from "@material-ui/core";
import LoadingClassesShimmer from "components/Shimmer/LoadingClassesShimmer";
const CustomGrid = (props) => {
  const {
    children,
    items,
    totalItems,
    hasMore,
    showLoading,
    loadMore,
    containerClass,
    loader,
    isError,
    isPageContainer,
    listClass
  } = props;
  return (
    <div className={isPageContainer ? `page-container ${containerClass}` : `${containerClass}`}>
      {/* <Filter paginatedDataOnDemand={paginatedDataOnDemand} /> */}
      <InfiniteScroll
        datalength={totalItems || items.length}
        loadMore={loadMore}
        hasMore={hasMore}
        loader={loader}
      >
        {/* <Grid container justifyContent="flex-start" spacing={spacing} className={classes}> */}
        <div className={isError ? "" : `list ${listClass}`}>
          {isError &&  children}
          {showLoading ? (
            <LoadingClassesShimmer
              myClass="custom-grid"
              totalCards={totalItems || items.length}
            />
          ) : (children instanceof Function)&&items.map((item, index) => (
            // <Grid item lg={4} md={6} sm={12} xs={12} key={index} className={itemClass}>
              <div key={index} >{children(item,index)}</div>
            //</Grid>
          ))}
          </div>
        {/* </Grid> */}
      </InfiniteScroll>
    </div>
  );
};
CustomGrid.defaultProps = {
    loader : null ,
    containerClass : '' ,
    itemClass:'collection',
    items : [],
    isPageContainer:true,
    showLoading:true,
    isError:false,
    hasMore:false,
    spacing:4,
    loadMore:()=>null
};
CustomGrid.propTypes = {
  items: PropTypes.array.isRequired,
  spacing: PropTypes.number,
  hasMore: PropTypes.bool,
  showLoading: PropTypes.bool,
  isPageContainer: PropTypes.bool,
  isError: PropTypes.bool,
  loadMore: PropTypes.func,
  classes: PropTypes.string,
  itemClass: PropTypes.string,
  containerClass: PropTypes.string,
  loader: PropTypes.oneOfType([PropTypes.func,PropTypes.number,null]),
  totalItems: PropTypes.oneOfType([PropTypes.number,PropTypes.string]),
};

export default CustomGrid;
